import React, { createContext, Dispatch, SetStateAction } from 'react';

export interface IStepsContext {
    steps: React.ReactNode[];
    stepNumber: number;
    setStepNumber: Dispatch<SetStateAction<number>>;
    titles: (string | null)[];
    allowedSteps: number[];
    setAllowedSteps: Dispatch<SetStateAction<number[]>>;
    errorSteps: number[];
    setErrorSteps: Dispatch<SetStateAction<number[]>>;
    warningSteps: number[];
    setWarningSteps: Dispatch<SetStateAction<number[]>>;
    submitLoading: boolean;
    onSubmit?: () => void;
    stepsClickable: boolean;
}

export const StepsContext = createContext<IStepsContext>({
    steps: [],
    stepNumber: 0,
    setStepNumber: () => undefined,
    titles: [],
    allowedSteps: [],
    setAllowedSteps: () => undefined,
    errorSteps: [],
    setErrorSteps: () => undefined,
    warningSteps: [],
    setWarningSteps: () => undefined,
    submitLoading: false,
    stepsClickable: true,
});
